import { contentsConstants } from '../constants';

const INITIAL_STATE = {
  fixedContent: false,
  fixedLoading: false,
  contents: [],
  contentsByStatus: [],
  paging: {
    page: 1,
    limit: 10,
    skip: 0,
    sort: { created: -1 },
    total: 0,
    search: '',
    statusCode: 'all'
  },
  contentLoading: false,
};

export function contents(state = INITIAL_STATE, action) {
  switch (action.type) {
    case contentsConstants.GET_FIXED_CONTENT_REQUEST:
      return {
        ...state,
        fixedLoading: true
      }

    case contentsConstants.GET_FIXED_CONTENT_SUCCESS:
      return {
        ...state,
        fixedLoading: false,
        fixedContent: action.payload
      }

    case contentsConstants.GET_FIXED_CONTENT_FAILURE:
      return state;

    case contentsConstants.GET_ALL_CONTENT_REQUEST:
      return {
        ...state,
        contentLoading: true
      }

    case contentsConstants.GET_ALL_CONTENT_SUCCESS:
      return {
        ...state,
        contentLoading: false,
        contents: action.payload
      }

    case contentsConstants.GET_ALL_CONTENT_FAILURE:
      return {
        ...state,
        contentLoading: false,
      }

    case contentsConstants.GET_CONTENTS_BY_STATUS_REQUEST:
      return {
        ...state,
        contentLoading: true
      }

    case contentsConstants.GET_CONTENTS_BY_STATUS_SUCCESS:
      return {
        ...state,
        contentLoading: false,
        contentsByStatus: action.payload.data,
      }

    case contentsConstants.GET_CONTENTS_BY_STATUS_FAILURE:
      return {
        ...state,
        contentLoading: false,
      }
   
    default: {
      return state;
    }
  }
}
